import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { useState } from 'react';
import StylePanel from './StylePanel';
import BlockPanel from './BlockPanel/BlockPanel';
import { useTranslation } from 'react-i18next';

function SidePanel() {
    const { t } = useTranslation();
    const [tab, setTab] = useState('1');

    return (
        <TabContext value={tab}>
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    marginX: 2,
                    mt: 1,
                }}
            >
                <TabList
                    variant="fullWidth"
                    centered
                    onChange={(e, value) => setTab(value)}
                >
                    <Tab label={t('Blocks')} value="1" />
                    <Tab label={t('Style')} value="2" />
                </TabList>
            </Box>
            <TabPanel
                value="1"
                sx={{ overflowY: 'scroll', scrollbarWidth: 'none' }}
            >
                <BlockPanel />
            </TabPanel>
            <TabPanel value="2" sx={{ overflowY: 'scroll', pr: 2 }}>
                <StylePanel />
            </TabPanel>
        </TabContext>
    );
}

export default SidePanel;
